"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = 'M1.25 12 a10.75,10.75 0 1,0 21.5 0 a10.75,10.75 0 1,0  -21.5,0 M17 12.75 h-10 c-1.5,0 -1.5,-1.5 0,-1.5 h10 c1.5,0 1.5,1.5 0,1.5 z';